import { render, staticRenderFns } from "./supplement-payment-query.vue?vue&type=template&id=0b8bb4cd"
import script from "./supplement-payment-query.vue?vue&type=script&lang=ts"
export * from "./supplement-payment-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports